module.exports = __webpack_public_path__ + "img/u9066.954430d8.png";